import {
  DefaultModalScreenOptions,
  DefaultStackScreenOptions,
  ModalPath,
  TabPath,
} from "@/constants/Navigation";
import { Stack } from "@/crossPlatform/expo-router";

const Layout = () => {
  return (
    <Stack>
      <Stack.Screen
        name={TabPath.Profile}
        options={DefaultStackScreenOptions}
      />
      <Stack.Screen
        name={ModalPath.SafetyPlanDetails}
        options={DefaultModalScreenOptions}
      />
    </Stack>
  );
};

// eslint-disable-next-line import-x/no-unused-modules -- Modal/Tab/TabLayout/Screen/Home get used in expo routing but in a way that TypeScript can not infer
export default Layout;
